// extracted by mini-css-extract-plugin
module.exports = {"WrapperStyle":"RFZOpage_WrapperStyle__3YBOK","RFZOArticleList":"RFZOpage_RFZOArticleList__Qhf13"};